import { ExpositionHall, LevelMeta } from '../../interfaces';
import {loadExpositionHall} from '../expositionhall-loader'
import ideasHall from './hall';

const id = 'ideas_map';
const name = 'Ideas Engineering';

export function loadMap() {
    const map: ExpositionHall = loadExpositionHall(ideasHall, id, name);
    //console.log('Loaded Map:', map);
    return map;
}

const meta: LevelMeta = {
    id,
    name,
    load: loadMap
};

export default meta;
